module.exports = __webpack_public_path__ + "static/media/1002403.c3aee4c8.png";